import filters from "../models/filters";

class FilterData {
    initiateFiltersInStorage() {
      let filterData = {};
      filters.map((obj) => {
        if (obj.type === "choice" && obj.multiple === true) {
          filterData[obj.key] = [];
        } else if (obj.type === "choice" && obj.multiple === false) {
          filterData[obj.key] = [];
        } else if (obj.type === "range") {
          filterData[obj.key] = [obj.min_range, obj.max_range];
        }
        return obj.key;
      });
      filterData = {...filterData, ...{fur:[]}};
      return filterData;
    }
}

export default FilterData;